import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient} from '@angular/common/http';
import { Util } from '../util.service';

@Injectable({
  providedIn: 'root'
})

export class StudentService {
  baseurl = Util.GetBaseUrl();

  constructor(private http: HttpClient, public router: Router) { }

  viewStudent() {
    return this.http.get(this.baseurl +'/api/Students/GetStudents')
  }

  addStudent(studentForm) {
    console.log(studentForm);
    return this.http.post(this.baseurl+'/api/Students', studentForm)
  }

  editStudent(id, studentForm) {
    console.log(studentForm);
    return this.http.put(this.baseurl +`/api/Students/${id}`, studentForm)
  }

  deleteStudent(id) {
    console.log(id);
    return this.http.delete(this.baseurl+`/api/Students/${id}`)
  }
}
